<script>
  import { onMount } from "svelte";

  import { ignore } from "../../../Common/tools";
  import {M} from "../../../external";

  export let data;
  export let valid = true;
  export let onChange = ignore;

  let note;

  let onValueChange = function () {
    data.name = note || "-";
    data.settings[0].value = note;
    valid = !!note;
    if (valid) {
      onChange();
    }
  };

  onMount(() => {
    if (!data) {
      data = {};
    }
    if (!data.settings) {
      data.settings = [
        {
          key: "note",
          value: ""
        }
      ];
    }
    note = data.settings[0].value || "";
    valid = !!note;
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.ADD_NOTE_SUBSCRIBER}</h4>
  <div class="multiple-items-picker mb-15 crm-filter-value">
    <label class="label">
      <input type="text" placeholder={M.ENTER_NOTE} on:change={onValueChange} bind:value={note} />
    </label>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mt-25 b-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
